module.exports = __webpack_public_path__ + "media/flags/nr-a7fe3560.svg";